import React from 'react';
import { _ } from '@hugendubel/utils';
import { ArticleBox } from './ArticleBox';
import { RoutingUrl } from '../../appRoutes';
import { BonusPoints } from '../../BonusPoints';
import { usePickupButtonHandler } from '../../hooks/usePickupButtonHandler';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

export type ArticleListEntryViewProps = { points: BonusPoints; article: ReducedProduct };

export const ArticleListEntryView: React.FC<ArticleListEntryViewProps> = ({ points, article }) => {
    const { price, deliveryInformation, articleId, availability } = article;
    // download - primitives boolean
    // bonusCost - nullable
    const BRANCH_ONLY_BONUS_ARTICLE = 210;
    const isPurchasable = price.bonusCost ? price.bonusCost <= points.value : false;
    const isBranchOnlyArticle = availability?.number === BRANCH_ONLY_BONUS_ARTICLE;

    const pickupButtonHandler = usePickupButtonHandler(article);

    return (
        <div
            className={_.classNames(
                'bonus-item col-12 col-sm-6',
                deliveryInformation && deliveryInformation.download && 'download'
            )}
        >
            <ArticleBox
                article={article}
                isPurchasable={isPurchasable}
                isBranchOnlyArticle={isBranchOnlyArticle}
                buyButtonUrl={RoutingUrl.delivery(articleId)}
                pickupButtonHandler={pickupButtonHandler}
                showPrice
            />
        </div>
    );
};
